import { createContext } from 'react';
import { initialState as authenticationState } from './reducer';
import { AuthenticationContextType } from './types';

export const defaultContext = {
  authenticationState,
  dispatchAuthenticationAction: () => {},
};
export const AuthenticationContext = createContext<AuthenticationContextType>(defaultContext);
